import { toast } from "react-toastify";
import { useMutation } from "@apollo/client/react";
import {
  DecisionType,
  RulesDocument,
  DeleteRuleMutation,
  DeleteRuleMutationVariables,
  DeleteRuleDocument,
} from "@/graphql/__generated__/graphql";
import useUserStore from "@/store/shield";
import { useTranslation } from "react-i18next";
import { CustomToastComponent } from "@/components/shared";

export default function useDeleteRuleMutationHook(
  decisionType?: DecisionType
): { deleteRuleMutation: any; loading: any; error: any } {
  const { t } = useTranslation(["toasts"]);

  const organizationID = useUserStore((state) => state.orgId);

  const [deleteRuleMutation, { loading, error }] = useMutation<DeleteRuleMutation, DeleteRuleMutationVariables>(
    DeleteRuleDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "rule-removed-success",
          data: {
            title: t("toasts.ruleremoved"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: RulesDocument,
          variables: { organizationId: Number(organizationID), decisionType },
        },
      ],
    });

  return {
    deleteRuleMutation,
    loading,
    error,
  };
}
